import { render, staticRenderFns } from "./ProfileSaved.vue?vue&type=template&id=6d2f5e06&scoped=true&"
import script from "./ProfileSaved.vue?vue&type=script&lang=js&"
export * from "./ProfileSaved.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSaved.vue?vue&type=style&index=0&id=6d2f5e06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f5e06",
  null
  
)

export default component.exports